import axios from 'axios';
import { API_NAME, DEFAULT_ERROR_MESSAGE, CSV_EXPORT_ERROR_MESSAGE } from '../const';
import { saveAs } from 'file-saver';
import moment from "moment"
import API from '@aws-amplify/api'
import { checkCurrentAuthenticatedUser } from 'utils/currentAuthenticatedUserChecker'

export async function exportCsv(apply_ids: string[]): Promise<void> {
  await checkCurrentAuthenticatedUser()
  // CSVを生成してS3に保存するAPIを呼び出す
  const { url_to_download_csv: urlToDownloadCsv } = await API
    .put(API_NAME, `/v2/csv`,
      {
        body: {
          apply_ids: apply_ids,
        }
      })
    .then(res => {
      return res;
    })
    .catch(err => {
      alert(CSV_EXPORT_ERROR_MESSAGE);
      throw err;
    });

  // S3に保存されたCSVを署名用URLでダウンロードする
  await axios.get(urlToDownloadCsv, {
    responseType: 'arraybuffer'
  })
    .then(res => {
      if (res.status !== 200) {
        throw new Error(`response status is not 200 [${res.status}]`);
      }
      return res.data;
    })
    .then(data => {
      const blob = new Blob([data]);
      saveAs(blob, `${moment().format("YYYYMMDDHHmmss")}.csv`);
    })
    .catch(err => {
      alert(DEFAULT_ERROR_MESSAGE);
      throw err;
    });
}

